export enum ObiQueryParams {
  CURRENT_PAY_PERIOD = 'CURRENT_PAY_PERIOD',
}
